import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './components.scss';
import './accessibility.scss';
import {
  CssBaseline,
  Experimental_CssVarsProvider as CssVarsProvider,
} from '@mui/material';
import { defaultTheme } from './theme/default/DefaultTheme';
import AppErrorBoundary from './ui/error-handler/AppErrorBoundary';
import datadogRum from './components/datadog-rum';

// Initialize Datadog RUM as early as possible
datadogRum.init();

// Track input intent so focus rings are shown for keyboard navigation only.
document.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') {
    document.body.classList.add('keyboard-nav');
  }
});

document.addEventListener('mousedown', () => {
  document.body.classList.remove('keyboard-nav');
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <CssVarsProvider theme={defaultTheme}>
      <CssBaseline />
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </CssVarsProvider>
  </React.StrictMode>
);
